import { ArrowsDownUpIcon as PhosphorArrowsDownUpIcon } from "@phosphor-icons/react/dist/ssr/ArrowsDownUp";

import { createAppIcon } from "@/components/createAppIcon";

export const PriceChangeIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowsDownUpIcon);
export const SortIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowsDownUpIcon);
